const styles = {
  searchRow: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    marginBottom: "24px",
  },
  searchColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    flexGrow: "1",
  },
  searchWrapper: {
    position: "relative",
    width: "100%",
  },
  searchInput: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minHeight: "40px",
    maxHeight: "40px",
    width: "100%",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "12px",
  },
  searchIconWrapper: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  },
  searchIcon: {
    fontSize: "22px",
    color: "#818898",
  },
  actionButtonsRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "4px",
  },
  btnCalendar: {
    display: "flex",
    height: "40px",
    borderColor: "#171821",
    width: "50px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    backgroundColor: "var(--Color-Primary-500, #171821)",
  },
  btnLocation: {
    display: "flex",
    height: "40px",
    width: "50px",
    borderColor: "#171821",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    backgroundColor: "var(--Color-Primary-500, #171821)",
  },
  listContainer: {
    flexDirection: "column",
    alignItems: "center",
  },
  servicesGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    alignContent: "flex-start",
    gap: "24px",
    alignSelf: "stretch",
    flexWrap: "wrap",
  },
  serviceItem: {
    minWidth: "340px",
    minHeight: "290px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
  },
  serviceCard: {
    display: "flex",
    minWidth: "340px",
    minHeight: "290px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    borderRadius: "4px",
    border: "1px solid var(--Color-Gray-100, #E3E3E3)",
  },
  thumbStyle: {
    display: "flex",
    paddingTop: "8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  serviceTitle: {
    display: "flex",
    minHeight: "50px",
    maxHeight: "50px",
    paddingTop: "16px",
    paddingRight: "8px",
    paddingBottom: "16px",
    paddingLeft: "8px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    color: "var(--Color-Primary-500, #171821)",
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
  },
  serviceMeta: {
    display: "flex",
    paddingTop: "8px",
    paddingRight: "8px",
    paddingBottom: "16px",
    paddingLeft: "8px",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    borderBottom: "1px solid var(--Color-Gray-100, #E3E3E3)",
  },
  durationRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    overflow: "hidden",
    color: "var(--Color-Primary-500, #171821)",
    textAlign: "center",
    textOverflow: "ellipsis",
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  serviceNote: {
    display: "webkit-box",
    alignSelf: "stretch",
    overflow: "hidden",
    color: "var(--Color-Primary-500, #171821)",
    textAlign: "center",
    textOverflow: "ellipsis",
    fontFamily: "inter,sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  },
  priceRow: {
    display: "flex",
    minHeight: "55px",
    maxHeight: "55px",
    width: "100%",
    paddingTop: "16px",
    paddingRight: "8px",
    paddingBottom: "16px",
    paddingLeft: "8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "self",
    borderRadius: "4px",
    margin: "0px",
  },
  checkboxRow: {
    display: "flex",
    padding: "12px",
    alignItems: "center",
    gap: "12px",
  },
  labelText: {
    display: "flex",
    color: "var(--Color-Primary-500, #171821)",
    textAlign: "center",
    fontFamily: "inter,sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
    margin: "0px",
    alignItems: "0px",
    gap: "10px",
  },
  checkboxInput: {
    display: "flex",
    margin: "0px",
    width: "18px",
    height: "18px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
  },
  noResultsStyle: {
    fontFamily: "inter, sans-serif",
  },
};

export default styles;
